import { genMessage } from '../helper';
import antdLocale from 'ant-design-vue/es/locale/en_US';

const modules = import.meta.globEager('./en/**/*.ts');

export default {
  ...genMessage(modules, 'en'),
  antdLocale,
};
